(function () {
  'use strict';
  if (window.bcjCartUpsellPromotionLoaded) return;
  window.bcjCartUpsellPromotionLoaded = true;

  var TILE = '.upcart-public-component-upsell-tile';
  var ROW = '.upcart-public-component-upsell-tile__price-row';
  var COMPARE = '.upcart-public-component-upsell-tile__price-compare-at';
  var handles = new Set(['elk-mesquite-meat-sticks', 'jalapeno-cheese-meat-stick',
    'teriyaki-meat-stick', 'hickory-venison-meat-sticks', 'peppered-beef-jerky',
    'jalapeno-honey-meat-sticks', 'original-meat-stick', 'habanero-heat-jerky',
    'sweet-heat-jerky', 'honey-bbq-jerky', 'teriyaki-pork-jerky', 'hickory-bbq-jerky',
    'original-beef-jerky', 'beefcake-jalapeno-cheese-beef-bites']);
  var cache = new Map();
  var roots = new WeakSet();
  var requests = new WeakMap();
  var discoveryTimer;

  function currency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency() }).format(cents / 100);
    } catch (_) { return (cents / 100).toFixed(2) + ' ' + currency(); }
  }

  function productHandle(tile) {
    var link = tile.querySelector('a[href*="/products/"]');
    if (!link) return '';
    try {
      var match = new URL(link.getAttribute('href'), window.location.origin).pathname.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) { return ''; }
  }

  function getProduct(handle) {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var key = base + ':' + currency() + ':' + (window.Shopify && window.Shopify.country || '') + ':' + handle;
    if (!cache.has(key)) {
      cache.set(key, fetch(base.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).catch(function () { cache.delete(key); return null; }));
    }
    return cache.get(key);
  }

  function variantFor(tile, product) {
    var selector = tile.querySelector('select');
    var variantId = selector && selector.value;
    if (!variantId) {
      var link = tile.querySelector('a[href*="/products/"]');
      try { variantId = link && new URL(link.getAttribute('href'), window.location.origin).searchParams.get('variant'); } catch (_) {}
    }
    if (variantId) return product.variants.find(function (variant) { return String(variant.id) === String(variantId); });
    return product.variants.length === 1 ? product.variants[0] : null;
  }

  function isSubscription(tile) {
    var plan = tile.querySelector('[name="selling_plan"]:checked') || tile.querySelector('select[name="selling_plan"], input[type="hidden"][name="selling_plan"]');
    return Boolean(plan && !plan.disabled && plan.value && plan.value !== '0');
  }

  function packReference(product, variant) {
    function count(value) {
      var match = String(value && (value.option1 || value.title) || '').match(/^(\d+)\s*(?:pack|bag|stick)?\b/i);
      return match ? Number(match[1]) : 0;
    }
    if (!product || !handles.has(product.handle) || !variant || !variant.available ||
      !Array.isArray(product.variants) || !count(variant) || !Number.isSafeInteger(variant.price) || variant.price < 0) return null;
    var baseline = product.variants.filter(function (value) {
      return value.available && count(value) && Number.isSafeInteger(value.price) && value.price > 0;
    }).sort(function (a, b) { return count(a) - count(b); })[0];
    if (!baseline || count(variant) <= count(baseline)) return null;
    var cents = Math.round(baseline.price * count(variant) / count(baseline));
    if (!Number.isSafeInteger(cents) || cents <= variant.price) return null;
    return { cents: cents, caption: count(baseline) === 1 ? 'Same quantity bought as single bags' :
      'Same quantity bought in ' + count(baseline) + '-packs' };
  }

  function restoreReference(row) {
    if (!row) return;
    row.querySelectorAll('[data-bcj-upsell-reference-hidden]').forEach(function (node) {
      node.removeAttribute('data-bcj-upsell-reference-hidden');
    });
    var display = row.querySelector('[data-bcj-upsell-reference]');
    if (display) display.remove();
  }

  function hideReference(row) {
    row.querySelectorAll(COMPARE).forEach(function (node) {
      node.setAttribute('data-bcj-upsell-reference-hidden', '');
      var label = node.previousElementSibling;
      if (label && label.classList.contains('upcart-internal__visually-hidden')) label.setAttribute('data-bcj-upsell-reference-hidden', '');
    });
  }

  function paintReference(row, product, variant) {
    var reference = packReference(product, variant), nativeReference = row.querySelector(COMPARE);
    if (!reference || !nativeReference) { restoreReference(row); return; }
    hideReference(row);
    var display = row.querySelector('[data-bcj-upsell-reference]');
    if (!display) {
      display = document.createElement('s');
      display.setAttribute('data-bcj-upsell-reference', '');
      nativeReference.insertAdjacentElement('beforebegin', display);
    }
    var text = money(reference.cents);
    if (display.textContent !== text) display.textContent = text;
    display.setAttribute('aria-label', reference.caption + ': ' + text);
    display.setAttribute('title', reference.caption);
  }

  function restore(row) {
    if (!row) return;
    row.removeAttribute('data-bcj-upsell-sale');
    var display = row.querySelector('[data-bcj-upsell-price]');
    if (display) display.remove();
  }

  function refreshTile(tile) {
    var row = tile.querySelector(ROW);
    var overview = window.BCJPromotion && window.BCJPromotion.details();
    var handle = productHandle(tile);
    var campaign = overview && overview.active;
    if (!row || !handle || isSubscription(tile) || (!campaign && !handles.has(handle))) {
      requests.delete(tile); restore(row); restoreReference(row); return;
    }
    var selector = tile.querySelector('select');
    var requestedCurrency = currency();
    var requestedRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var requestedCountry = window.Shopify && window.Shopify.country || '';
    var signature = [handle, selector && selector.value, requestedCurrency, requestedRoot, requestedCountry, Boolean(campaign)].join(':');
    var previous = requests.get(tile);
    if (previous && previous.signature === signature && previous.pending) return;
    if (!previous || previous.signature !== signature) { restore(row); restoreReference(row); }
    if (campaign) restoreReference(row);
    else { restore(row); hideReference(row); }
    var request = { signature: signature, pending: true };
    requests.set(tile, request);
    getProduct(handle).then(function (product) {
      if (requests.get(tile) !== request) return;
      request.pending = false;
      if (!tile.isConnected || !product || !Array.isArray(product.variants)) { restore(row); return; }
      if (currency() !== requestedCurrency || requestedRoot !== (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') ||
        requestedCountry !== (window.Shopify && window.Shopify.country || '')) { refreshTile(tile); return; }
      // Read the selector after the request settles; a shopper may already have changed it.
      row = tile.querySelector(ROW);
      if (!row || productHandle(tile) !== handle) return;
      var variant = variantFor(tile, product);
      overview = window.BCJPromotion && window.BCJPromotion.details();
      if (!overview || !overview.active) {
        restore(row);
        if (isSubscription(tile)) restoreReference(row);
        else paintReference(row, product, variant);
        return;
      }
      restoreReference(row);
      var promotion = variant && variant.available && window.BCJPromotion && window.BCJPromotion.details({
        handle: handle, variantId: variant.id, price: variant.price,
        sellingPlanId: isSubscription(tile) ? 'subscription' : ''
      });
      if (!promotion || !promotion.active || promotion.price >= variant.price) { restore(row); return; }

      var display = row.querySelector('[data-bcj-upsell-price]');
      var label = 'Beefcake Days · ' + promotion.percent + '% off one-time';
      var markupKey = [variant.id, variant.price, promotion.price, promotion.percent, currency()].join(':');
      if (!display) {
        display = document.createElement('span');
        display.setAttribute('data-bcj-upsell-price', '');
        display.innerHTML = '<s data-bcj-upsell-was></s> <strong data-bcj-upsell-now></strong><small data-bcj-upsell-label></small>';
        row.appendChild(display);
      }
      if (display.dataset.bcjPriceKey !== markupKey) {
        display.querySelector('[data-bcj-upsell-was]').textContent = money(variant.price);
        display.querySelector('[data-bcj-upsell-now]').textContent = money(promotion.price);
        display.querySelector('[data-bcj-upsell-label]').textContent = label;
        display.setAttribute('aria-label', 'Original price ' + money(variant.price) + '. Sale price ' + money(promotion.price) + '. ' + label);
        display.dataset.bcjPriceKey = markupKey;
      }
      row.setAttribute('data-bcj-upsell-sale', '');
    });
  }

  function connect() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (!root) return;
    window.clearInterval(discoveryTimer);
    if (roots.has(root)) return;
    roots.add(root);
    var style = document.createElement('style');
    style.textContent = '[data-bcj-upsell-sale] > :not([data-bcj-upsell-price]){display:none!important}' +
      '[data-bcj-upsell-reference-hidden]{display:none!important}' +
      '[data-bcj-upsell-reference]{font-size:.8em;opacity:.6}' +
      '[data-bcj-upsell-price]{display:inline-block!important;line-height:1.2}' +
      '[data-bcj-upsell-was]{font-size:.8em;opacity:.6;margin-right:4px}' +
      '[data-bcj-upsell-label]{display:block;font-size:10px;white-space:normal;margin-top:4px;color:#b83e14}';
    root.appendChild(style);
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        root.querySelectorAll(TILE).forEach(refreshTile);
      });
    }
    // Only native Upcart mutations trigger work; our price display never observes itself.
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return !target || !target.closest('[data-bcj-upsell-price], [data-bcj-upsell-reference]');
      })) schedule();
    }).observe(root, { childList: true, subtree: true, characterData: true });
    root.addEventListener('change', schedule);
    window.addEventListener('bcj:promotion:change', schedule);
    window.addEventListener('aftersell-upcart:public-events:cart-opened', schedule);
    schedule();
  }

  discoveryTimer = window.setInterval(connect, 1000);
  new MutationObserver(connect).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', connect);
  connect();
})();
